import { Link } from 'react-router-dom';
import { useSettings } from '@/hooks/useProducts';
import { useRecentlyViewed } from '@/hooks/useRecentlyViewed';
import { formatCurrency } from '@/lib/utils';
import BrandSymbol from '@/components/BrandSymbol';

export default function RecentlyViewed({ excludeId }: { excludeId?: string }) {
  const { data } = useSettings();
  const { getItems } = useRecentlyViewed();

  const config = data?.settings?.upsell_config?.recently_viewed;
  if (!config?.enabled) return null;

  const items = getItems(excludeId, config.max_items || 8);
  if (items.length === 0) return null;

  return (
    <section className="mt-12" aria-labelledby="recently-viewed-heading">
      <h2 id="recently-viewed-heading" className="text-xl font-bold text-ink mb-4">
        Recently Viewed
      </h2>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 snap-x snap-mandatory">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/product/${item.slug}`}
            className="flex-none w-40 sm:w-48 snap-start group"
          >
            <div className="aspect-square rounded-lg overflow-hidden bg-surface-muted mb-2">
              {item.image_url ? (
                <img
                  src={item.image_url}
                  alt={item.name}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              ) : (
                <div className="h-full w-full flex items-center justify-center">
                  <BrandSymbol className="h-8 w-8 text-ink-muted" />
                </div>
              )}
            </div>
            <p className="text-sm font-medium text-ink truncate group-hover:text-sage-700 transition-colors">
              {item.name}
            </p>
            <p className="text-sm font-bold text-sage-700">{formatCurrency(item.price)}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
